import Tippy from './tippy/Main.vue'
import TippyContent from './tippy-content/Main.vue'

export default (app) => {
  app.component('Tippy', Tippy)
  app.component('TippyContent', TippyContent)
}
